/* eslint-disable no-restricted-imports */
import React, {useMemo, useState} from 'react'
import styles from './GameTip.module.scss'
import {t, T} from '../../../../common/T'
import {useUIGameSettingsContext} from '../../../../contexts/UIGameSettingsContext'
import {useUIGameEndContext} from '../../../../contexts/UIGameEndContext'
import {TranslationArrayKeys, TranslationObject} from '@colonist/i18n'
import {RandomUtils} from '@colonist/utils'
import {ClientUserState} from '../../../../../../../code/client/shared/scripts/ClientUserState'
import {GameTypeEnum} from '@colonist/types'
import {StorageWrapper} from '../../../../../../../code/client/shared/scripts/StorageWrapper'
import {CA} from '../../../../../../../code/client/shared/scripts/analytics/Analytics'
import {AnalyticEventType, AnalyticEventCategory} from '../../../../../../../code/shared/entity_datas/EntityDatas'
import {ViewPopupRankedGameDescription} from '../../../../../../../code/client/shared/scripts/ui_popup/ViewPopupRankedGameDescription'

interface GameTipText {
    title: TranslationObject
    subtitle: TranslationObject
}

const enum USER_ACTION_ENUM {
    EXPLORE_RANKED = 1,
    DONT_SHOW_AGAIN = 2,
}

export const GameTip = () => {
    const {gameType} = useUIGameSettingsContext()
    const {isMyColorWinner} = useUIGameEndContext()

    const defaultShowRankedIncentive = useMemo(() => {
        const isBotGame = gameType == GameTypeEnum.BotGame
        const isBotEndGameRankedCTA = ClientUserState.abTests.BOT_ENDGAME_RANKED_CTA == 'SHOW_BOT_ENDGAME_RANKED_CTA'
        const isEndGameRankedCTAEnabled = StorageWrapper.getShowEndGameRankedCTA()
        return isBotGame && isBotEndGameRankedCTA && isEndGameRankedCTAEnabled
    }, [gameType])
    const [showRankedIncentive, setShowRankedIncentive] = useState(defaultShowRankedIncentive)

    const randomWinnerTip = useMemo(() => {
        const gameOutcome = isMyColorWinner ? 'winner' : 'loser'
        const gameTips = t<GameTipText[]>(`strings:game.endGame.rankedIncentive.outcome.${gameOutcome}` as TranslationArrayKeys, undefined, true)

        const randomIndex = RandomUtils.randomIntBetween(0, gameTips.length - 1)
        return gameTips[randomIndex]
    }, [isMyColorWinner])

    const clickAction = (action: USER_ACTION_ENUM) => {
        void CA.sendAnalyticEvent({
            type: AnalyticEventType.ABTestClickAnalytics,
            category: AnalyticEventCategory.ABTestBotEndGameRankedCTA,
            floatValue: action,
        })

        if(action == USER_ACTION_ENUM.EXPLORE_RANKED) {
            new ViewPopupRankedGameDescription()
            return
        }
        StorageWrapper.setShowEndGameRankedCTA(false)
        setShowRankedIncentive(false)
    }

    if(!showRankedIncentive) return <></>

    return (
        <div className={styles.container}>
            <div className={styles.content}>
                <h2><T id={randomWinnerTip.title} /></h2>
                <p><T id={randomWinnerTip.subtitle} /></p>
            </div>
            <div className={styles.buttons}>
                <span className={styles.exploredRanked} onClick={() => clickAction(USER_ACTION_ENUM.EXPLORE_RANKED)}>
                    <T id='strings:game.endGame.rankedIncentive.buttonNames.exploreRanked' />
                </span>
                <span className={styles.dontShowAgain} onClick={() => clickAction(USER_ACTION_ENUM.DONT_SHOW_AGAIN)}>
                    <T id='strings:game.endGame.rankedIncentive.buttonNames.dontShowAgain' />
                </span>
            </div>
        </div>
    )
}
